<template>
<div>
  <v-card>
    <v-card-title>
      Categorías
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="assemblies"
      :search="search"
      :loading="loadingTable"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.description }}</td>
        <td class="text-xs-center" :class="props.item.status == 1 ? '' : ''">{{ props.item.status == 0 ? 'inActiva' : 'Activa' }}</td>
        <td class="text-xs-center">
          <v-tooltip top>
          <v-icon
            medium
            class="mr-2"
            @click="editItem(props.item)"
            slot="activator"
          >
            edit
          </v-icon>
          <span>Editar</span>
        </v-tooltip>
          <v-tooltip top>
          <v-icon
            :disabled="props.item.eStatus == 1"
            medium
            @click="deleteItem(props.item)"
            slot="activator"
          >
            delete
          </v-icon>
          <span>Eliminar</span>
        </v-tooltip>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</div>

</template>
<script>
import axios from 'axios'
import Form from 'vform';

export default {
  name: 'assemblies-show-view',
  data() {
    return {
      search: '',
      headers: [
        { text: 'Descripcion', align: 'center', value: 'description' },
        { text: 'Estado', align: 'center', value: 'status' },
        { text: 'Acción', align: 'center', value: 'assembly_date', sortable: false }
      ],
      assemblies: [],
      dialogAssembly: '',
      dialogIdAssembly: 0,
      dialog: false,
      userNameMaxLength: 60,
      entries: [],
      isLoading: false,
      currentMemberSearch: null,
      searchBoardMembers: null,
      boardMembersHeaders: [
        { text: 'Actions', value: 'name', sortable: false, align: 'center' }
      ],
      boardMembers: [],
      boardMembersSearch: '',
      showCreateMemberForm: false,
      createMemberForm: new Form({
        name: ''
      }),
      loadingTable: false,
    }
  },
  created() {
    this.getCategorysList()
  },
  methods: {
    async getCategorysList() {
      this.loadingTable = true;
      const { data } = await axios.get('/api/categorys')
      this.assemblies = data;
      this.loadingTable = false;
    },
    editItem(item) {
      this.$router.push({ name: 'category.edit', params: {id: item.id}});
    },
    async deleteItem(item) {
      await axios.delete(`/api/categorys/${item.id}`)
      this.assemblies = this.assemblies.filter(assembly => assembly.id !== item.id);
    }
  },
  computed: {
    usersResult() {
      return this.entries.map(user => {
        user.name.length > this.userNameMaxLength
          ? user.name.slice(0, this.userNameMaxLength) + '...'
          : user.name

        return Object.assign({}, user)
      })
    }
  },

  watch: {
    searchBoardMembers(val) {
      if (!val) return
      if (this.isLoading) return

      this.isLoading = true

      axios.get(`/api/assembly/search_board_members/${val}`)
        .then(res => {
          const { data } = res
          this.count = data.length;
          this.entries = data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    }
  }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/pages/eventCategorys/show.vue